import { extractEvmAddresses } from './EvmUtils';
// One embedded-wallet address is the same on every EVM chain, so mainnet stands in for all of them
const EVM_REFERENCE_CHAIN = 'eip155:1';
// Magic-issued addresses only. The smart account is a Safe the secure site derives from the EOA,
// so Magic never records it and the warehouse has nothing to match it against.
export function buildCaipAccounts(account) {
    const { eoaAddress } = extractEvmAddresses(account);
    const solanaAddress = account?.solana?.caipAddress;
    const accounts = [];
    if (eoaAddress) {
        accounts.push(`${EVM_REFERENCE_CHAIN}:${eoaAddress}`);
    }
    if (solanaAddress) {
        accounts.push(solanaAddress);
    }
    return accounts;
}
//# sourceMappingURL=AccountUtils.js.map